// @flow

import { hpfetch } from '../util';
import type { reviewDimensionType } from '../../types';
import type {
  djangoModelApiResponse,
  wrappedApiResponseType,
} from '../apiTypes';

export const getSingle = (
  id: number,
): Promise<wrappedApiResponseType<reviewDimensionType>> =>
  hpfetch(`reviews/dimensions/${id}/`);

export const getMany = (): djangoModelApiResponse<reviewDimensionType> =>
  hpfetch(`reviews/dimensions/`);

export const getSingleByCategoryId = (
  categoryId: number,
): djangoModelApiResponse<reviewDimensionType> =>
  hpfetch(`reviews/dimensions/?category=${categoryId}`);
